import { Button, Card, Empty, Form, Input, Layout, message, Modal, Pagination, Space, Spin, Typography, Divider, Popconfirm } from 'antd'
import { ArrowLeftOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { Content } from 'antd/lib/layout/layout'
import dayjs from 'dayjs'
import SiderMenuMain from '../../../components/SiderMenuMain'
import NavBreadcrumb from '../../../components/NavBreadcrumb'
import NavHeader from '../../../components/NavHeader'
import IsRender from '../../../components/isRender'
import NavFooter from '../../../components/NavFooter'
import AxiosUtil from '../../../utils/AxiosUtil'
import styles from './notice.module.less'

type INotice = { id?: number; title: string; summary: string }
type INoticeDetail = {
  id: number
  announcementId?: any
  publishDate?: any
  title: string
  createUser?: any
  createTime?: any
  updateTime?: any
  flag: number
  remark?: any
  isVerify?: any
  summary: string
  user_count: number
}
export type INoticeList = { total: number; list: INoticeDetail[] }

const initNoticeList: INoticeList = { total: 1, list: [] }
const pageSize = 10
const crumb = [{ name: '系统管理' }, { name: '平台公告' }]

const editNotice = (params: INotice, callback: (suc: boolean, dat: INoticeDetail) => void) => {
  AxiosUtil.AxiosRequest('/api/announcement/edit', { ...params, type: 1 }, callback)
}

export default function Notice() {
  const [noticeList, setNoticeList] = useState<INoticeList>(initNoticeList)
  const [curNotice, setCurNotice] = useState<INoticeDetail>({} as INoticeDetail)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [pageIndex, setPageIndex] = useState(1)
  const [loading, setLoading] = useState(false)
  const [addForm] = Form.useForm()

  const loatNoticeList = (pageIndex: number, pageSize: number) => {
    setLoading(true)
    AxiosUtil.AxiosRequest('/api/announcement/list', { pageIndex, pageSize, type: 1 }, (suc, dat) => {
      if (suc) setNoticeList(dat)
      else setNoticeList(initNoticeList)
      setLoading(false)
    })
  }
  const onClickNotice = (item: INoticeDetail) => {
    setCurNotice(item)
    const newList = noticeList.list.map((notice) => {
      if (notice.id === item.id) return { ...item, user_count: item.user_count ? ++item.user_count : 1 }
      else return notice
    })
    setNoticeList({ ...noticeList, list: newList })
    AxiosUtil.AxiosRequest('/api/announcement/editAnnouncementDUser', { announcementId: item.announcementId }, () => {})
  }
  const onClickReturn = () => setCurNotice({} as INoticeDetail)
  const onClickDel = (item: INoticeDetail) => {
    AxiosUtil.AxiosRequest('/api/announcement/delete', { id: item.id }, (suc) => {
      if (suc) {
        message.success('删除成功 !')
        loatNoticeList(pageIndex, pageSize)
      } else message.error('删除失败 !')
    })
  }
  const onClickEdit = (item: INoticeDetail) => {
    setIsEditing(true)
    setIsModalOpen(true)
    addForm.setFieldsValue(item)
  }

  const onFormFinish = (values: INotice) => {
    editNotice(values, (suc) => {
      if (suc) {
        message.success('公告' + (isEditing ? '修改' : '添加') + '成功 !')
        if (pageIndex === 1) loatNoticeList(pageIndex, pageSize)
        else setPageIndex(1) // pageIndex 发生变化, 自动加载 noticeList
        onHiddenModal()
      }
    })
  }
  const onAddNotice = () => {
    setIsEditing(false)
    setIsModalOpen(true)
  }
  const onHiddenModal = () => {
    setIsEditing(false)
    setIsModalOpen(false)
    addForm.resetFields()
  }

  useEffect(() => loatNoticeList(pageIndex, pageSize), [pageIndex])

  return (
    <Layout>
      <NavHeader />
      <Content className={'main-body'}>
        <Layout>
          <SiderMenuMain />
          <Content className={'main-content ' + styles.notice}>
            <NavBreadcrumb itemList={crumb} />
            <Spin spinning={loading}>
              <Card
                title={'平台公告'}
                className={'notice-box'}
                extra={
                  <Button type={'primary'} onClick={onAddNotice}>
                    添加公告
                  </Button>
                }
                headStyle={{ fontWeight: 700 }}
                bodyStyle={{ minHeight: '100%' }}
              >
                <IsRender isRender={noticeList.total} children2={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}>
                  <IsRender
                    isRender={!curNotice.id}
                    children2={
                      <div className={'notice-detail-box'}>
                        <div className={'notice-detail-title'}>{curNotice?.title}</div>
                        <div className={'notice-detail-text'}>
                          {curNotice.summary &&
                            curNotice.summary.split('\n').map((item, index) => (
                              <p className={index ? 'notice-detail-section' : ''} key={item}>
                                {item}
                              </p>
                            ))}
                        </div>
                        <div className={'notice-detail-back'}>
                          <Button type={'link'} onClick={onClickReturn}>
                            <ArrowLeftOutlined /> 返 回
                          </Button>
                        </div>
                      </div>
                    }
                  >
                    <ul className={'notice-box-ul'}>
                      {noticeList.list.map((item) => (
                        <li key={item.id} className={'notice-item ' + (item.user_count ? '' : 'not-read')}>
                          <div className={'item-content-box'} onClick={() => onClickNotice(item)}>
                            <div>&gt; {item.title}</div>
                            <div>{item.publishDate && dayjs(item.publishDate).format('YYYY-MM-DD')}</div>
                          </div>
                          <div className={'item-operate-box'}>
                            <Space size={10} split={<Divider type={'vertical'} />}>
                              <Popconfirm title={'确认删除该公告吗 ?'} onCancel={onHiddenModal} onConfirm={() => onClickDel(item)}>
                                <Typography.Link>
                                  <DeleteOutlined />
                                </Typography.Link>
                              </Popconfirm>
                              <Typography.Link onClick={() => onClickEdit(item)}>
                                <EditOutlined />
                              </Typography.Link>
                            </Space>
                          </div>
                        </li>
                      ))}
                    </ul>
                    <Pagination
                      className={'pagination'}
                      current={pageIndex}
                      pageSize={pageSize}
                      total={noticeList.total}
                      showSizeChanger={false}
                      onChange={setPageIndex}
                    />
                  </IsRender>
                </IsRender>
              </Card>
            </Spin>
            <Modal
              title={(isEditing ? '修改' : '添加') + '平台公告'}
              visible={isModalOpen}
              onOk={addForm.submit}
              onCancel={onHiddenModal}
              width={600}
              destroyOnClose
              okText={isEditing ? '修改' : '添加'}
            >
              <Form form={addForm} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} onFinish={onFormFinish}>
                <Form.Item hidden name={'id'}>
                  <Input />
                </Form.Item>
                <Form.Item label={'公告标题'} name={'title'} rules={[{ required: true, message: '请输入平台公告标题' }]}>
                  <Input placeholder={'请输入平台公告标题 !'} />
                </Form.Item>
                <Form.Item label={'公告内容'} name={'summary'} rules={[{ required: true, message: '请输入平台公告内容' }]}>
                  <Input.TextArea style={{ height: 200, resize: 'none' }} placeholder={'请输入平台公告内容 !'} />
                </Form.Item>
              </Form>
            </Modal>
          </Content>
        </Layout>
      </Content>
      <NavFooter />
    </Layout>
  )
}
